var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_vm._l((_vm.creators),function(creator,index){return _c('div',{key:index},[_c('CreatorViewer',{attrs:{"creator":creator}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }